<template>
  <div class="pay-page">
    <div class="header">
      <div class="header__top-wrapper">
        <div class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">{{ $t('Payment Info') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="pay-body">
      <div class="amount-card">
        <div class="amount-row">
          <span class="amount">{{ (info.amount || 0) | vnd }}</span>
          <span class="unit">{{ currencySymbol }}</span>
        </div>
        <div class="countdown" v-if="orderState === 1">
          {{ $t('Pay within') }}
          <span class="time">{{ pad(m) }}:{{ pad(s) }}</span>
          {{ $t('to complete payment') }}
        </div>
        <div class="status-text" :class="'state-' + orderState">{{ statusText }}</div>
        <div class="hint">{{ $t('After payment, wait for review') }}</div>
        <div class="hint">
          {{ $t('If you have questions, please') }}
          <span class="link" @click="$parent.openKefu">{{ $t('Contact Customer Service') }}</span>
        </div>
      </div>

      <div class="detail-card">
        <div class="row" v-if="isBankPay && card.bank_name">
          <span class="label">{{ $t('Bank name') }}</span>
          <span class="value">
            {{ card.bank_name }}
            <em class="copy" @click="doCopy(card.bank_name)">{{ $t('Copy') }}</em>
          </span>
        </div>
        <div class="row" v-if="receiveAccount">
          <span class="label">{{ isBankPay ? $t('Receiving account') : $t('Payment address') }}</span>
          <span class="value">
            <span class="break">{{ receiveAccount }}</span>
            <em class="copy" @click="doCopy(receiveAccount)">{{ $t('Copy') }}</em>
          </span>
        </div>
        <div class="row" v-if="isBankPay && card.bank_owner">
          <span class="label">{{ $t('Account holder') }}</span>
          <span class="value">
            {{ card.bank_owner }}
            <em class="copy" @click="doCopy(card.bank_owner)">{{ $t('Copy') }}</em>
          </span>
        </div>
        <div class="row" v-if="isBankPay && card.bank_address">
          <span class="label">{{ $t('Branch') }}</span>
          <span class="value">{{ card.bank_address }}</span>
        </div>
        <div class="row">
          <span class="label">{{ $t('Order number') }}</span>
          <span class="value">
            {{ payInfo.deposit_no }}
            <em class="copy" @click="doCopy(payInfo.deposit_no)">{{ $t('Copy') }}</em>
          </span>
        </div>
        <div class="row">
          <span class="label">{{ $t('Transaction time') }}</span>
          <span class="value">{{ info.created_at }}</span>
        </div>
        <div class="row">
          <span class="label">{{ $t('Payment method') }}</span>
          <span class="value">{{ info.paytype }}</span>
        </div>
        <div class="row" v-if="type === 'usdtpay' && card.content">
          <span class="label">{{ $t('Wallet protocol') }}</span>
          <span class="value">{{ card.content }}</span>
        </div>

        <div class="qr-wrap" v-if="card.payimg">
          <img :src="card.payimg" alt="qr" />
          <p>{{ $t('Scan QR to pay') }}</p>
        </div>
        <p class="exact-hint">{{ $t('Please transfer the exact amount') }}</p>
      </div>

      <div class="voucher-card" v-if="canUploadVoucher">
        <div class="voucher-title">{{ $t('Upload payment voucher') }}</div>
        <label class="upload-box">
          <input type="file" accept="image/*" @change="onPickVoucher" />
          <img v-if="voucherPreview" :src="voucherPreview" alt="voucher" class="preview" />
          <span v-else>{{ $t('Tap to upload screenshot') }}</span>
        </label>
        <button
          :class="['btn-submit', { disabled: uploading || !voucherData }]"
          :disabled="uploading || !voucherData"
          @click="submitVoucher"
        >
          {{ uploading ? $t('Uploading') : $t('Submit voucher') }}
        </button>
        <p v-if="voucherUploaded" class="wait-text">{{ $t('Voucher uploaded, waiting for review') }}</p>
      </div>
      <div class="voucher-card" v-else-if="voucherPreview">
        <div class="voucher-title">{{ $t('Upload payment voucher') }}</div>
        <img :src="voucherPreview" alt="voucher" class="preview preview-only" />
      </div>

      <div class="footer-actions">
        <div class="action-btn" @click="$parent.goNav('/transRecord')">{{ $t('Deposit completed') }}</div>
        <div class="action-btn ghost" @click="$parent.goNav('/transRecord')">{{ $t('Fund Details') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: { info: {}, cardlist: {}, deposit_no: '' },
      type: '',
      daoTime: null,
      m: 0,
      s: 0,
      voucherData: '',
      voucherPreview: '',
      voucherUploaded: false,
      uploading: false,
    };
  },
  computed: {
    info() {
      return this.payInfo.info || {};
    },
    card() {
      const c = this.payInfo.cardlist;
      if (Array.isArray(c)) return c[0] || {};
      return c || {};
    },
    isBankPay() {
      return this.type === 'bankpay';
    },
    receiveAccount() {
      return this.card.bank_no || this.card.mch_id || this.card.wallet_address || '';
    },
    orderState() {
      const state = Number(this.info.state);
      return Number.isFinite(state) && state > 0 ? state : 1;
    },
    canUploadVoucher() {
      return this.orderState === 1;
    },
    statusText() {
      if (this.orderState === 2) return this.$t('Approved');
      if (this.orderState === 3) return this.$t('Rejected');
      if (this.voucherUploaded) return this.$t('Waiting for review');
      return this.$t('Waiting for review');
    },
  },
  created() {
    const query = this.$route.query;
    if (query.deposit_no) {
      this.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    pad(n) {
      return n >= 10 ? n : `0${n}`;
    },
    doCopy(msg) {
      if (!msg) return;
      const cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.$parent.showTost(1, this.$t('Copied successfully!'));
    },
    getpayinfo(deposit_no) {
      this.$parent.showLoading();
      this.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        if (res.code != 200) {
          this.$parent.showTost(0, res.message);
          this.$parent.hideLoading();
          return;
        }
        this.payInfo = Object.assign({ deposit_no: this.$route.query.deposit_no }, res.data || {});
        this.type = res.message || '';
        const existing = (this.info && this.info.voucher_url) || this.card.voucher || '';
        if (existing) {
          this.voucherPreview = existing;
          this.voucherUploaded = true;
        }
        this.countTime();
        this.$parent.hideLoading();
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    onPickVoucher(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$parent.showTost(0, this.$t('Please upload payment voucher'));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.voucherData = reader.result;
        this.voucherPreview = reader.result;
      };
      reader.readAsDataURL(file);
    },
    submitVoucher() {
      if (!this.voucherData || this.uploading) return;
      this.uploading = true;
      this.$parent.showLoading();
      this.$apiFun.post('/api/recharge/voucher', {
        deposit_no: this.payInfo.deposit_no,
        voucher: this.voucherData,
      }, { timeout: 30000 }).then(res => {
        this.uploading = false;
        this.$parent.hideLoading();
        if (res.code != 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        this.voucherUploaded = true;
        if (res.data && res.data.voucher) {
          this.voucherPreview = res.data.voucher;
        }
        this.$parent.showTost(1, res.message || this.$t('Voucher uploaded, waiting for review'));
      }).catch(() => {
        this.uploading = false;
        this.$parent.hideLoading();
      });
    },
    countTime() {
      if (!this.info.created_at) return;
      const now = Date.now();
      const createdTime = new Date(this.info.created_at).getTime();
      const leftTime = createdTime + 1000 * 60 * 60 - now;
      if (leftTime >= 0) {
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.daoTime = setTimeout(this.countTime, 1000);
      } else {
        this.m = 0;
        this.s = 0;
        this.daoTime = null;
      }
    },
  },
  beforeDestroy() {
    if (this.daoTime) {
      clearTimeout(this.daoTime);
      this.daoTime = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.pay-page {
  min-height: 100vh;
  background: #ffffff;
  color: #352b24;
}
.nav-header {
  background: #1f3b6d;
}
.van-nav-bar__title,
.van-nav-bar__arrow {
  color: #fff;
}
.pay-body {
  padding: 70px 15px 30px;
}
.amount-card,
.detail-card,
.voucher-card {
  background: #ffffff;
  border: 1px solid #eadfd3;
  border-radius: 16px;
  padding: 20px 16px;
  margin-bottom: 16px;
  box-shadow: 0 5px 18px rgba(117, 73, 34, 0.08);
}
.amount-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  .amount {
    font-size: 36px;
    font-weight: 800;
    color: #8f501f;
  }
  .unit {
    font-size: 16px;
    color: #b87333;
    font-weight: 700;
  }
}
.countdown {
  margin-top: 8px;
  text-align: center;
  color: #8a6a4a;
  font-size: 13px;
  .time {
    color: #c0392b;
    font-weight: 700;
    margin: 0 4px;
  }
}
.status-text {
  margin-top: 10px;
  text-align: center;
  font-weight: 700;
  color: #d1a03e;
  &.state-2 { color: #2e7d32; }
  &.state-3 { color: #c0392b; }
}
.hint {
  margin-top: 6px;
  text-align: center;
  font-size: 12px;
  color: #8a6a4a;
  .link {
    color: #8f501f;
    font-weight: 700;
  }
}
.row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f3e6d6;
  font-size: 13px;
  .label {
    color: #8a6a4a;
    flex-shrink: 0;
  }
  .value {
    text-align: right;
    color: #352b24;
    word-break: break-all;
  }
  .break {
    display: inline-block;
    max-width: 180px;
    word-break: break-all;
    vertical-align: middle;
  }
}
.copy {
  font-style: normal;
  margin-left: 8px;
  color: #d1a03e;
  font-weight: 700;
}
.qr-wrap {
  margin-top: 16px;
  text-align: center;
  img {
    width: 72%;
    max-width: 260px;
    display: block;
    margin: 0 auto 8px;
    border-radius: 8px;
    background: #fff;
  }
  p {
    font-size: 13px;
    color: #8a6a4a;
  }
}
.exact-hint {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #c0392b;
}
.voucher-title {
  font-weight: 700;
  margin-bottom: 12px;
}
.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
  border: 1px dashed #d9b98f;
  border-radius: 12px;
  background: #fff8ef;
  color: #8a6a4a;
  font-size: 13px;
  overflow: hidden;
  input {
    display: none;
  }
  .preview {
    width: 100%;
    max-height: 220px;
    object-fit: contain;
  }
}
.preview-only {
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  border-radius: 12px;
}
.btn-submit {
  margin-top: 14px;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;
  font-size: 16px;
  font-weight: 800;
  &.disabled {
    background: #ece4d8;
    color: #a89888;
  }
}
.wait-text {
  margin-top: 10px;
  text-align: center;
  color: #8f501f;
  font-size: 13px;
}
.footer-actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  .action-btn {
    flex: 1;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ffe082, #d1a03e);
    color: #4a2e00;
    font-weight: 700;
    font-size: 14px;
    &.ghost {
      background: #fff8ef;
      border: 1px solid #ead1b2;
      color: #8f501f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue